import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import styled from "@emotion/styled"
import { breakpoints } from "../../../utils/style"

const BlogWrap = styled("div")`
  .posts {
    display: flex;
    flex-flow: row wrap;
    margin-top: 60px;
  }
  .item {
    width: calc(100%/2);
    padding: 0 2% 2% 0;
    display: flex;
    &:nth-of-type(2n) {
      padding-right: 0;
    }
  }
  .image-wrap {
    flex-basis: 30%;
  }
  .text-wrap {
    flex-basis: 70%;
    padding-left: 20px;
    .h5 {
      font-size: 18px;
      line-height: 24px;
      font-weight: 500;
    }
  }
  .button {
    margin-top: 20px;
  }
  @media (max-width: ${breakpoints.md}) {
    .posts {
      display: block;
    }
    .item {
      width: 100%;
      padding: 0 0 24px;
      display: block;
    }
    .image-wrap {
      margin-bottom: 16px;
    }
    .text-wrap {
      padding-left: 0;
    }
  }
`

const Blog = () => {
  const { allWordpressPost, placeholder } = useStaticQuery(
    graphql`
      query BlogPosts {
        allWordpressPost(
          sort: { fields: date, order: DESC }
          filter: { categories: { elemMatch: { wordpress_id: { eq: 51 } } } }
          limit: 4
        ) {
          edges {
            node {
              title
              excerpt
              slug
              featured_media {
                alt_text
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 500) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
        placeholder: file(relativePath: { eq: "placeholder.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 500) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )

  return (
    <BlogWrap>
      <h2 className="h1 rich-design">
        <span>Blog</span>
      </h2>
      <div className="decorative-line" />
      <div className="posts">
        {allWordpressPost.edges.map(({ node }) => (
          <Link className="item" key={node.slug} to={"/" + node.slug + "/"}>
            <div className="image-wrap">
              {node.featured_media &&
              node.featured_media.localFile &&
              node.featured_media.localFile.childImageSharp &&
              node.featured_media.localFile.childImageSharp.fluid ? (
                <Img
                  fluid={node.featured_media.localFile.childImageSharp.fluid}
                  alt={
                    node.featured_media.alt_text
                      ? node.featured_media.alt_text
                      : node.title
                  }
                />
              ) : (
                <Img
                  fluid={placeholder.childImageSharp.fluid}
                  alt={node.title}
                />
              )}
            </div>
            <div className="text-wrap">
              <span className="h5">{node.title}</span>
              <div
                className="excerpt"
                dangerouslySetInnerHTML={{ __html: node.excerpt.slice(0, 250) }}
              />
              <span className="button white-button">อ่านเพิ่มเติม</span>
            </div>
          </Link>
        ))}
      </div>
    </BlogWrap>
  )
}

export default Blog